import type { BaseErrorResponse, LoginReq, LoginRes, RefreshReq } from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useAuth() {
  class Auth<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerLogin
     * @summary Login
     * @request POST:/api3/auth/login
     * @response `200` `LoginRes`
     * @response `400` `BaseErrorResponse`
     */
    authControllerLogin = (data: LoginReq, params: RequestParams = {}) =>
      this.request<LoginRes, BaseErrorResponse>({
        path: '/api3/auth/login',
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerRefreshToken
     * @summary Token refresh
     * @request POST:/api3/auth/refresh-token
     * @response `200` `LoginRes`
     * @response `400` `BaseErrorResponse`
     */
    authControllerRefreshToken = (data: RefreshReq, params: RequestParams = {}) =>
      this.request<LoginRes, BaseErrorResponse>({
        path: '/api3/auth/refresh-token',
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new Auth();
}
